import React from 'react';
import configureStore from 'redux-mock-store';
import { Provider } from 'react-redux';
import { TestCoreComponent, TestCoreComponentProps } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Company, Language, Platform } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { initialStateMock } from '@store';
import { Anything } from '@types';

export interface TestComponentProps {
	state?: Record<string, Anything>;
	coreProps?: TestCoreComponentProps;
}

export const TestComponent: React.FC<TestComponentProps> = ({ children, state = {}, coreProps }) => {
	coreProps = coreProps
		? coreProps
		: {
				company: Company.bcp,
				language: Language.pt,
				platform: Platform.mobile,
		  };

	const mockStore = configureStore();
	const store = mockStore({
		...initialStateMock,
		...state,
	});

	return (
		<Provider store={store}>
			<TestCoreComponent data-test="test-component" {...coreProps}>
				{children}
			</TestCoreComponent>
		</Provider>
	);
};
